import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

//компонент Предпочтительные каналы связи
const CommunicationChannels = ({userSettings = {}, setUserSettingsHandler}) => {
  return (
    <div className="modal__icons_profile">
      <div className="EmailPopup__dontshow modal__icon_block_profile-first">
          <img src={userSettings.notifyEmail ? "/assets/img/communication_channels/email-icon.png" 
          : "/assets/img/communication_channels/email-icon-dark.png"} alt="email-on" className="modal__icon_profile-first" onClick={setUserSettingsHandler('notifyEmail')}/>
        <div className="Form__field modal__text_profile" style={{color: userSettings.notifyEmail ? "#ffffff": "#000000"}}><FormattedMessage id='profile_edit.email'/></div>
      </div>
      <div className="EmailPopup__dontshow modal__icon_block_profile">
        <img src={userSettings.notifyPhone ? "/assets/img/communication_channels/phone-icon.png" 
        : "/assets/img/communication_channels/phone-icon-dark.png"} alt="email-on" className="modal__icon_profile" onClick={setUserSettingsHandler('notifyPhone')}/>
        <div className="Form__field modal__text_profile" style={{color: userSettings.notifyPhone ? "#ffffff": "#000000"}}><FormattedMessage id='profile_edit.phone'/></div>
      </div>
      <div className="EmailPopup__dontshow modal__icon_block_profile">
        <img src={userSettings.notifySMS ? "/assets/img/communication_channels/sms-icon.png" 
        : "/assets/img/communication_channels/sms-icon-dark.png"} alt="email-on" className="modal__icon_profile" onClick={setUserSettingsHandler('notifySMS')}/>
        <div className="Form__field modal__text_profile" style={{color: userSettings.notifySMS ? "#ffffff": "#000000"}}><FormattedMessage id='profile_edit.sms'/></div>
      </div>
      <div className="EmailPopup__dontshow modal__icon_block_profile">
        <img src={userSettings.notifyTelegram ? "/assets/img/communication_channels/telegram-icon.png"
          : "/assets/img/communication_channels/telegram-icon-dark.png"} alt="email-on" className="modal__icon_profile" onClick={setUserSettingsHandler('notifyTelegram')}/>
        <div className="Form__field modal__text_profile" style={{color: userSettings.notifyTelegram ? "#ffffff": "#000000"}}><FormattedMessage id='profile_edit.telegram'/></div>
      </div>
      <div className="EmailPopup__dontshow modal__icon_block_profile">
        <img src={userSettings.notifyWhatsapp ? "/assets/img/communication_channels/whatsapp-icon.png"
          : "/assets/img/communication_channels/whatsapp-icon-dark.png"} alt="email-on" className="modal__icon_profile" onClick={setUserSettingsHandler('notifyWhatsapp')}/>
        <div className="Form__field modal__text_profile" style={{color: userSettings.notifyWhatsapp ? "#ffffff": "#000000"}}><FormattedMessage id='profile_edit.whatsapp'/></div>
      </div>
      {/*<div className="EmailPopup__dontshow modal__icon_block_profile">
        <img src={userSettings.notifyFacebook ? "/assets/img/communication_channels/facebook-icon.png"
          : "/assets/img/communication_channels/facebook-icon-dark.png"} alt="facebook-on" className="modal__icon_profile" onClick={setUserSettingsHandler('notifyFacebook')}/>
        <div className="Form__field modal__text_profile" style={{color: userSettings.notifyFacebook ? "#ffffff": "#000000"}}><FormattedMessage id='profile_edit.facebook'/></div>
      </div>*/}
    </div>
  )
}

const mapState = (state, { userSettings, setUserSettings }) => ({
    userSettings: userSettings,
    setUserSettings: setUserSettings
  })
  const mapDispatch = (dispatch, { setUserSettings, userSettings }) => ({
    setUserSettingsHandler: field => value => {
      userSettings[field] = !userSettings[field]
      dispatch(setUserSettings())
    }
  })

export default injectIntl(compose(
  connect(mapState, mapDispatch)
)(CommunicationChannels))



// WEBPACK FOOTER //
// ./src/components/CommunicationChannels.jsx